<template>
  <div>
    <div class="d-flex justify-content-center mb-3">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading"
}
</script>

<style scoped>

</style>